import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Button from './Button';

var OnceButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(OnceButton, _PureComponent);

  var _super = _createSuper2(OnceButton);

  function OnceButton(props) {
    var _this;

    _classCallCheck(this, OnceButton);

    _this = _super.call(this, props);
    _this.state = {
      loading: props.loading
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OnceButton, [{
    key: "handleClick",
    value: function handleClick(e) {
      var onClick = this.props.onClick;
      this.setState({
        loading: true
      });
      if (onClick) onClick(e);
    }
  }, {
    key: "render",
    value: function render() {
      return (
        /*#__PURE__*/
        React.createElement(Button, Object.assign({}, this.props, {
          loading: this.state.loading,
          onClick: this.handleClick
        }))
      );
    }
  }]);

  return OnceButton;
}(PureComponent);

export default OnceButton;